export const PATIENT_TAGS = {
    VIP: { color: "bg-amber-100 text-amber-700 border-amber-200" },
    INSURER: { color: "bg-blue-100 text-blue-700 border-blue-200" },
    TRAUMATOLOGY: { color: "bg-emerald-100 text-emerald-700 border-emerald-200" },
    DEFAULT: { color: "bg-red-100 text-red-700 border-red-200" },
    POST_OP: { color: "bg-purple-100 text-purple-700 border-purple-200" },
    SPORTSMAN: { color: "bg-orange-100 text-orange-700 border-orange-200" },
    MINOR: { color: "bg-indigo-100 text-indigo-700 border-indigo-200" },
  } as const;
  
  // Extraemos los IDs automáticamente: esto crea un array ["VIP", "ASEGURADORA", ...]
  export const PATIENT_TAG_IDS = Object.keys(PATIENT_TAGS) as Array<keyof typeof PATIENT_TAGS>;